import React, { useEffect, useState } from "react";
import { track } from "../utils/analytics";

const DAY_KEY = "muraja.goalReminder.day";

function todayStamp() {
  // Local calendar date — the reminder is about *their* day, not UTC's.
  return new Date().toLocaleDateString("en-CA");
}

// FirstRunWelcome calls this on dismissal so a brand-new user doesn't get
// the welcome's goal echo and this toast in the same session.
export function markGoalReminderShown() {
  try {
    localStorage.setItem(DAY_KEY, todayStamp());
  } catch {
    // Best-effort.
  }
}

const COPY = {
  5: "5 quiet minutes today is enough.",
  10: "10 focused minutes today is enough.",
  15: "15 minutes today — steady and unhurried.",
  30: "Half an hour today — ما شاء الله، make it count.",
};

/**
 * DailyGoalReminder — a once-a-day greeting toast for users who chose a
 * daily-minutes goal in onboarding. It says its piece and fades: no button,
 * no CTA, no tracking of misses — the app invites, it never nags. Shown at
 * most once per local calendar day per device.
 */
export default function DailyGoalReminder({ minutes, enabled = true }) {
  const [phase, setPhase] = useState("hidden"); // hidden | shown | leaving

  useEffect(() => {
    if (!enabled || !minutes || !COPY[minutes]) return undefined;
    try {
      if (localStorage.getItem(DAY_KEY) === todayStamp()) return undefined;
      localStorage.setItem(DAY_KEY, todayStamp());
    } catch {
      return undefined; // no storage → rather silent than nagging every mount
    }
    setPhase("shown");
    track("goal-reminder-shown", { minutes });
    const fade = setTimeout(() => setPhase("leaving"), 6000);
    const gone = setTimeout(() => setPhase("hidden"), 6800);
    return () => {
      clearTimeout(fade);
      clearTimeout(gone);
    };
  }, [enabled, minutes]);

  if (phase === "hidden") return null;

  return (
    <div
      role="status"
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-40 transition-opacity duration-700 ${
        phase === "leaving" ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="surface-glass rounded-full px-5 py-2.5 shadow-2xl flex items-center gap-2.5 animate-rise">
        <span dir="rtl" lang="ar" className="font-amiri text-lg text-dt-gold-bright select-none">
          السَّلَامُ عَلَيْكُم
        </span>
        <span className="text-sm text-dt-parchment whitespace-nowrap">— {COPY[minutes]}</span>
      </div>
    </div>
  );
}
